import React, { useEffect, useState } from "react";
import { getStaff } from "../../api/user";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import AvatarMultiSelectCheckBoxWithoutBorders from "../AvatarMultiSelectCheckBoxWithoutBorders";

const StaffMultiSelectCheckBoxWithoutBorders = (props: any) => {
  const { manageOnFocus, manageChange, selectedList, manageOnBlur, overrideList, isReadOnly } = props;
  const [staffList, setStaffList] = useState([]);
  const clubDetails = useSelector((state: any) => state.clubDetails);
  const isAdmin = useSelector((state:any) => state.common.isAdmin);
  const [t] = useTranslation();

  const fetchStaffList = async () => {
    const response = await getStaff(!isAdmin && { clubId: clubDetails?.id });
    setStaffList(response);
  };

  useEffect(() => {
    staffList?.length === 0 && fetchStaffList();
  }, []);

  const manageSelectedValues = (updatedValue: any) => {
    const selectedId = updatedValue?.id;

    var tempArr = [updatedValue];
    if(selectedList?.length > 0) {
      const filteredArr = selectedList?.filter((item:any) => selectedId !== item.id);
      tempArr = filteredArr?.length === selectedList?.length ? [updatedValue, ...filteredArr] : filteredArr;
    }

    manageChange({ members: tempArr });
  };

  return (
    <Box
      onMouseDown={(e: any) => {
        e.stopPropagation();
        manageOnFocus(e);
      }}
      onClick={(e: any) => {
        e.stopPropagation();
        manageOnFocus(e);
      }}
      onBlur={manageOnBlur}
    >
      <AvatarMultiSelectCheckBoxWithoutBorders
        options={overrideList == null ? staffList : overrideList}
        selectedValues={selectedList}
        setSelectedValues={manageSelectedValues}
        manageOnFocus={manageOnFocus}
        label={t('SELECT_MEMBERS')}
        isReadOnly={isReadOnly}
      />
    </Box>
  );
};

export default StaffMultiSelectCheckBoxWithoutBorders;
